var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccuracyEnhanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-744 -266)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(744 266)",
    opacity: 0,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,9.6,9,15,7.4,9.6,2,8,7.4,6.4,9,1l1.6,5.4L16,8,10.6,9.6M17,14.2,21,12l-2.2,4L21,20l-4-2.2L13,20l2.2-4L13,12l4,2.2M10,16,8.3,19,10,22,7,20.3,4,22l1.7-3L4,16l3,1.7L10,16",
    transform: "translate(744 266)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracyEnhanceIcon);
export default __webpack_public_path__ + "static/media/accuracyEnhanceIcon.ec5d4f25aeb4be63fcd29d7956a65489.svg";
export { ForwardRef as ReactComponent };